import React from "react";
import {
  buildCreditBlockFollowUpMessage,
  buildCreditBlockInitialMessage,
} from "./creditPaymentBlock";

const CreditPaymentBlockModal = ({
  visible,
  mode = "payment",
  message = "",
  count = 0,
  orders = [],
  followUp = false,
  onConfirm,
  onDismiss,
}) => {
  if (!visible) {
    return null;
  }

  const hasPayableOrders = Array.isArray(orders) && orders.length > 0;

  const displayMessage =
    mode === "expired"
      ? message
      : followUp
        ? buildCreditBlockFollowUpMessage()
        : buildCreditBlockInitialMessage(count);

  return (
    <>
      <div className="bg-gray" onClick={onDismiss} />
      <div className="logout-modal work-start-modal">
        <span className="ques work-start-question">{displayMessage}</span>
        <div className="btns">
          {mode === "expired" ? (
            hasPayableOrders ? (
              <>
                <button type="button" onClick={onDismiss} className="stay">
                  خیر
                </button>
                <button type="button" onClick={onConfirm} className="exit work-start-yes">
                  پرداخت فاکتور اعتباری
                </button>
              </>
            ) : (
              <button type="button" onClick={onDismiss} className="exit work-start-yes">
                متوجه شدم
              </button>
            )
          ) : (
            <>
              <button type="button" onClick={onDismiss} className="stay">
                خیر
              </button>
              <button type="button" onClick={onConfirm} className="exit work-start-yes">
                بله
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CreditPaymentBlockModal;
